module.exports = __webpack_public_path__ + "static/media/laugh_janett.750c516b.mp3";